export const footerNavigation = [
  {
    headlineText: 'Customer Support',
    headlineLink: '/support/',
  },
  {
    headlineText: 'Courses',
    headlineLink: '/drivers-ed/',
  },
  {
    headlineText: 'Driver Resources',
    headlineLink: '/driving-information/',
  },
  {
    headlineText: 'Become a Partner',
    headlineLink: '/affiliates/',
  },
  {
    headlineText: 'Accessibility Statement',
    headlineLink: '/accessibility-statement/',
  },
];
